import { ValuesDTO } from "./valuesDTO";
import { CalculatorInputsDTO } from "./CalculatorInputsDTO";


export class InvestmentDTO {
    investmentIdentifier: string;
    valuesUpMarket: ValuesDTO;
    valuesDownMarket: ValuesDTO;
    valuesCustomMarket: ValuesDTO;
    calculatorInputsDTO: CalculatorInputsDTO;
    valuesDownMarketLessThanEqualBuffer: ValuesDTO;
    valuesDownMarketGreaterThanBuffer: ValuesDTO;
    constructor(investmentIdentifier: string, valuesDownMarket: ValuesDTO,valuesUpMarket: ValuesDTO, valuesCustomMarket: ValuesDTO, calculatorInputsDTO: CalculatorInputsDTO, valuesDownMarketLessThanEqualBuffer: ValuesDTO, valuesDownMarketGreaterThanBuffer: ValuesDTO) {
        this.investmentIdentifier = investmentIdentifier;
        this.valuesUpMarket = valuesUpMarket;
        this.valuesDownMarket = valuesDownMarket;
        this.valuesCustomMarket = valuesCustomMarket;
        this.calculatorInputsDTO = calculatorInputsDTO;
        this.valuesDownMarketLessThanEqualBuffer = valuesDownMarketLessThanEqualBuffer;
        this.valuesDownMarketGreaterThanBuffer = valuesDownMarketGreaterThanBuffer;
    }
}

